export const kycStatuses = {
  ALL: {
    statusDesc: "All",
    statusColor: "primary",
  },
  FULL_KYC: {
    statusDesc: "Full KYC",
    statusColor: "success",
  },
  PARTIAL_KYC: {
    statusDesc: "Partial KYC",
    statusColor: "secondary",
  },
};

export const extendedKycStatuses = {
  ...kycStatuses,
  REJECTED: {
    statusDesc: "Rejected",
    statusColor: "danger",
  },
};

export const LIMITS_STORAGE_NAME = "active-limits-list";

export const GOOGLE_MAPS_KEY = window.env
  ? window.env.GOOGLE_MAPS_KEY
  : "AIzaSyCVVdespDBOlwIAIPr6EdrgzuIpxEKDKVQ";

// Portal deployed for the Bakong Tourist PG; enables GDI passport verification.
export const IS_TOURIST_PG = window.env ? window.env.PG_MODE === "TOUR" : false;

export const MAX_FILE_SIZE_IN_BYTES = 1 * 1024 * 1024;

export const ERROR_CODES = {
  PASSWORD_HISTORY_VIOLATION: 93,
  PASSWORD_EXPIRES: 94,
  PASSWORD_TOO_YOUNG: 95,
  PASSWORD_EXPIRED: 96,
  FORCE_CHANGE_PASSWORD: 97,
};
